import AttributeElement from './AttributeElement';

export default AttributeElement;
